import r from "validator/lib/isURL.js";
const i = (t) => {
  try {
    const o = new URL(t || "");
    return o.search = "", o.toString();
  } catch {
    return t || "";
  }
}, c = (t) => r(t, {
  require_protocol: !0,
  protocols: ["http", "https"],
  require_tld: !0,
  disallow_auth: !0
}), a = (t) => t.includes("http://") || t.includes("https://"), u = (t) => {
  var e;
  if (!t)
    return !0;
  const o = new URL(t).hostname.replace("www", "");
  return (typeof window < "u" ? (e = window == null ? void 0 : window.location) == null ? void 0 : e.host : "").includes(o);
}, l = () => "https://www.pelando.com.br/api/static/assets/loading.gif";
export {
  l as getPelandoLoadingGif,
  u as isInternalLink,
  c as isPublicHttpUrl,
  i as removeQueryParams,
  a as urlHasProtocol
};
